import { render, staticRenderFns } from "./ShopSalesComponent.vue?vue&type=template&id=244ece0f&scoped=true&"
import script from "./ShopSalesComponent.vue?vue&type=script&lang=js&"
export * from "./ShopSalesComponent.vue?vue&type=script&lang=js&"
import style0 from "./ShopSalesComponent.vue?vue&type=style&index=0&id=244ece0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ece0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VContainer,VDataTable,VRow})
